import '../styles/CustomSnackBar.scss'

import * as React from 'react'
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

interface Props {
    isOpened:boolean
    className:string
    contentClassName:string
    message:any
    onClose:(event) => void
    onSnackBarClick?:() => void
}


export default class CustomSnackBar extends React.Component<Props, {}> {
  constructor(props: any) {
    super(props)
  }

  onCloseIconClick = (event:any) =>{
      this.props.onClose(event)
  }

  render() {
      return(
        <Snackbar
        className={this.props.className}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={this.props.isOpened}
        onClick={this.props.onSnackBarClick}
    >
        <SnackbarContent
            className={this.props.contentClassName}
            aria-describedby="client-snackbar"
            message={this.props.message}
            action={
                <IconButton
                    key="close"
                    aria-label="Close"
                    color="inherit"
                    onClick={this.onCloseIconClick}
                >
                    <CloseIcon />
                </IconButton>
            }
        />
    </Snackbar>
      )
   
}

}


// WEBPACK FOOTER //
// ./src/components/CustomSnackBar.tsx